<template>
    <div>
      <b-row class="mt-3">
        <b-col cols="5">
          <b-form-group label="Report Type: "  :label-cols="3" >
            <b-form-select class="form-control input" v-model="reportType" disabled>
              <option :value="null"  >--Please Select Type--</option>
                <option value="daywise">Day Wise</option>
              </b-form-select>          
          </b-form-group> 
        </b-col>
        <b-col cols="5">
          <b-form-group label="Hub : "  :label-cols="3" >
            <b-form-select class="form-control input" v-model="destinationhubid" :disabled="isSuperAdmin!=1">
              <option :value="null"  >--Please Select Hub--</option>
                <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
              </b-form-select>          
          </b-form-group> 
        </b-col>
        <b-col cols="4">
          <b-form-group label="From Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="fromDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="To Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="toDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:left;">
          <b-form-group>
            <button class="btn btn-primary" @click="getHubDayWiseOFPListing(1)"> Search </button>                       
            <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:right;">
            <b-form-group>
              <button class="btn btn-primary" @click="performanceReport" :disabled="totalRows==0">Download </button>                       
            </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="text-right">
          <b-col sm="12">  
            <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
          </b-col>
        </b-col> 

        <b-col sm="12">
          <b-table 
            show-empty 
            responsive
            :items="items" 
            :busy="isBusy" 
            :current-page="currentPage"
            :fields="fields" 
            :per-page="perPage" 
            :bordered="bordered">

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            <template slot="total_pickup_shipments" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'total_pickup_shipments')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.total_pickup_shipments }}</span>
              </button>
            </template>

            <template slot="total_pickup_exchange" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'total_pickup_exchange')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.total_pickup_exchange }}</span>
              </button>
            </template>

            <template slot="ofp_pickup_shipments" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'ofp_pickup_shipments')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.ofp_pickup_shipments }}</span>
              </button>
            </template>

          </b-table>
        </b-col>
        <b-col sm="12" class="my-1" v-if="this.totalRows>10">
          <paginate 
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :current-page="currentPage"
          >
          </paginate>
        </b-col>
        <b-modal size="xl" title="Details" v-model="detailsModal" hide-footer>
        <b-row>
          <b-col sm="12" class="text-right">
            <b-form-group>
              <button class="btn btn-primary" @click="countDetailsReport" :disabled="totalRowsCount==0">Download </button>                       
            </b-form-group>
          </b-col>
          <b-col sm="12" class="text-right">
            <p > <b>Total Records :<span style="color:red;">{{ totalRowsCount }}</span></b> </p>
          </b-col>
          <b-col sm="12">
            <b-table
              show-empty 
              responsive
              :items="items1" 
              :busy="isBusy1" 
              :current-page="currentPage1"
              :fields="fields1" 
              :bordered="bordered"
            >

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            </b-table>
          </b-col>
        </b-row>
      </b-modal>
      </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
  export default {
    data: function(){
      return{
        name:'hubWiseOFPReport_KSA',
        isBusy: false,
        items: [],
        fields: [
          {key:'hub_name',label:'Hub Name'},
          {key:'ofp_date',label:'Date'},
          {key:'total_pickup_shipments',label:'Total Pickup Shipment'},
          {key:'total_pickup_exchange',label:'Pickup Exchange'},
          {key:'ofp_pickup_shipments',label:'OFP Pickup Shipment'},
          {key:'pickup_done_percentage',label:'Pickup Done Percentage'},
          {key:'pickup_cancel_percentage',label:'Pickup Cancel Percentage'},
          {key:'pickup_exchange_done_percentage',label:'Pickup Exchange Done Percentage'},
          {key:'pickup_exchange_cancel_percentage',label:'Pickup Exchange Cancel Percentage'},
        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:10,
        noofpages: 0,
        destinationhubid:null,
        reportType:'daywise',
        hublist:[],
        toDate:new Date(),
        fromDate:new Date(),
        downloadreport:'',
        isSuperAdmin:0,

        //modal fields
        detailsModal:false,
        isBusy1: false,
        items1:[],
        fields1:[
          {key:'shippingid',label:'Shipping Id [Order Id]'},
          {key:'pickuplocationname',label:'Pickup Location Name'},
          {key:'servicetype',label:'Service Type'},
          {key:'shipmentstatus',label:'Shipment Status'},
          {key:'deliverystatus',label:'Delivery Status'},
          {key:'agent_name',label:'Agent Name'},
          {key:'customer_name_no',label:'Customer Name & Mob No.'},
          {key:'vendor_name',label:'Vendor Name'},
          {key:'da_mo_no',label:'DA Mobile Number'},
          {key:'delivery_addr',label:'Delivery Address'},
          {key:'ordertype',label:'Order Type'},
          {key:'createddate',label:'Created Date'},
          {key:'lastmodifieddate',label:'Last Modified Date'}
        ],
        totalRowsCount:0,
        currentPage1: 1,
        perPage1:15,

        data:[],
        countName:"",

        //count details download
        downloadcountdetailsreport:'',
      }
    },

    created: function(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isSuperAdmin = userInfo.is_superadmin
      var hubId = userInfo.pickuplocationmasterid;
      this.destinationhubid= this.isSuperAdmin != 1 ? hubId : null
      this.getHublist();
      //this.getHubDayWiseOFPListing(1);
    },

    methods:{
      getHublist:function(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.isSuperAdmin = userInfo.is_superadmin
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id:currenthub.toString()
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
        .then(result => {
          if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
          }
        })
        .catch(ex => {
          console.log('error', ex)
        });
      },

      getHubDayWiseOFPListing: function(pageNo){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        //var hubId = userInfo.pickuplocationmasterid;
        this.isBusy = true;

        if(!this.destinationhubid){
          this.$fire({
            text: "Please Select Hub!!!",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return
        }

        if(this.fromDate > this.toDate){
          this.$fire({
            text: "From date must be smaller than To date",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return
        }
        else{
          const Obj = {
            from_date: this.formatDate(this.fromDate),
            to_date: this.formatDate(this.toDate),
            hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
            // hub_id:"",
            limit: this.perPage,
            page_no: pageNo ? pageNo : 1     
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDaywiseHubOFPReportListing`,Obj)
          .then(result=>{
            if(result.status==200){
              if(result.body && result.body.returnmsg === 'Successful'){
                this.items = result.body.returnvalue;
                this.totalRows = result.body.totalCount;
                this.noofpages=parseInt(this.totalRows)/this.perPage;
                this.noofpages=Math.ceil( this.noofpages);
                console.log("noofpages-->",this.noofpages)
              }
              else{
                this.items = [];
                this.totalRows = 0;
                this.noofpages = 0;
                this.$fire({
                  text: result.body.returnvalue,
                  type: "warning",
                  timer: 30000
                });
              }
            }else{
              this.items = [];
              this.totalRows = 0;
              this.noofpages = 0;
              this.$fire({
                text: "Error while fetching Data!!!",
                type: "warning",
                timer: 30000
              }); 
            }
            
            this.isBusy = false;
            })
          .catch(ex =>{
            this.items = [];
            this.totalRows = 0;
            this.noofpages = 0;
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            }); 
            this.isBusy = false;
            console.log('error',ex)
          })
        }
      },

      performanceReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var hubId = userInfo.pickuplocationmasterid;

        const Obj={
          from_date: this.formatDate(this.fromDate),
          to_date: this.formatDate(this.toDate),
          hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
          //hub_id:""
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDaywiseHubOFPReportCSV`,Obj)
        .then(result=>{
          if(result.body){
            this.downloadReport(result.body)
          }
          else{
            this.downloadreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadReport(data){
        const csvData = data
        console.log("Data for download---> ",csvData);
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = 'hubDayWiseOFPReport.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },

      viewDetails(data,countName){
        this.data = data;
        this.countName = countName;
        this.displayHubOFPDayWiseDetails(data,countName);
        this.totalRowsCount=0;
        this.detailsModal=true;
      },

      displayHubOFPDayWiseDetails:function(data,countName){
        console.log("details api called")
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        //this.isBusy1 =true;

        const Obj = {
          date : data.ofp_date,
          hub_id : data.hub_id.toString(),
          //rider_id : data.ofpriderid.toString(),
          count_name:countName,
          // downloadAsCSV: 'false'
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDetailsForHubDaywiseOFPReportListingCount`,Obj)
        .then(result=>{
          if(result.status==200){
            if(result.body && result.body.returnmsg === 'Successful'){
              this.items1=result.body.returnvalue;
              this.totalRowsCount=result.body.returnvalue.length;
              //this.detailsModal=true;
            }
            else{
              this.items1=[];
              this.totalRowsCount=0;
              //this.detailsModal=false;
              this.$fire({
                text:result.body.returnvalue,
                type: "warning",
                timer: 30000
              });
            }
          }else{
            this.items1=[];
            this.totalRowsCount=0;
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            });
          }
          
          this.isBusy1 = false;
        })
        .catch(ex=>{
          this.items1=[];
          this.totalRowsCount=0;
          this.$fire({
            text: "Error while fetching Data!!!",
            type: "warning",
            timer: 30000
          });
          this.isBusy1 = false;
          console.log('error',ex)
        })

      },

      countDetailsReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

        const Obj={
          date : this.data.ofp_date,
          hub_id : this.data.hub_id.toString(),
          count_name: this.countName,
          downloadAsCSV: 'true'
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDetailsForHubDaywiseOFPReportListingCount`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadCountReport(result.body)
          }
          else{
            this.downloadcountdetailsreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadCountReport(data) {
        const csvData = data;
        console.log("Data for download---> ", csvData);

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const anchor = document.createElement('a');
        const url = URL.createObjectURL(blob);

        anchor.href = url;
        anchor.download = 'hubDayWiseOFPReportCountDetails.csv';

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(url);
      },

      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
      },

      clickCallback(pageNo){
        this.getHubDayWiseOFPListing(pageNo)
      },

      refresh(){
        if(this.isSuperAdmin == 1){
          this.destinationhubid=null;
        }
        this.fromDate = new Date();
        this.toDate = new Date();
        this.items = [];
        this.totalRows = 0;
        this.noofpages = 0;
        //this.getHubDayWiseOFPListing(1);
      },
    }
  }
</script>

<style>

</style>